import { SavedCard } from '../services/payment-method-state.service';
import { globalMessages } from '../../../shared/global-message';
import {
  BillingToken,
  CardPaymentDetails,
  EFTPaymentDetailsForEFT,
} from '../../../shared/models/billing.model';
import { resolvePaymentOwner, replaceSpecialCharacters } from './payment-card.util';

export interface BillingAccountInfo {
  accountId: string;
  accountPlanCode: string;
  collectionMethod: string;
}

/**
 * Build the DC Update_DefaultPaymentMethod request payload.
 */
export function buildBillingUpdateRequest(
  card: SavedCard,
  account: BillingAccountInfo,
  policyHolderName: string
): any {
  const isCreditCard = card.paymentMethodType === globalMessages.paymentTypeCreditCard;
  const newCollectionMethod = isCreditCard
    ? globalMessages.collectionMethodEFTC
    : globalMessages.collectionMethodEFT;

  const request: any = {
    action: globalMessages.billingActionUpdateDefault,
    AccountId: account.accountId,
    AccountPlanCode: account.accountPlanCode,
    CollectionMethod: account.collectionMethod || newCollectionMethod,
    NewCollectionMethodSelected: newCollectionMethod,
  };

  if (isCreditCard) {
    const token: BillingToken = { PaymentProfileID: card.id };
    const cardPaymentDetails: CardPaymentDetails = {
      CardNumber: card.lastFour,
      CardType: card.creditCardType || card.type.toUpperCase(),
      ExpirationDate: card.expiryDate,
      PaymentOwner: resolvePaymentOwner(card.cardholderName, policyHolderName),
      Token: token,
      SourceSystem: globalMessages.sourceSystemBP_HUB,
      PaymentMethod: card.creditCardNetworkType || globalMessages.paymentMethodCredit,
    };
    request.EFTPaymentDetails = {
      CardPaymentDetails: cardPaymentDetails,
      AccountName: replaceSpecialCharacters(card.cardholderName ?? ''),
    };
  } else {
    const eftDetails: EFTPaymentDetailsForEFT = {
      AccountName: replaceSpecialCharacters(card.cardholderName ?? ''),
      AccountType: card.bankAccountType ?? '',
      BankAccountNumber: card.lastFour,
      BanklastFour: card.lastFour,
      BankName: card.bankName ?? '',
      PaymentProfileID: card.id,
      PaymentOwner: resolvePaymentOwner(card.cardholderName, policyHolderName),
      SourceSystem: globalMessages.sourceSystemBP_HUB,
    };
    request.EFTPaymentDetails = eftDetails;
  }

  return request;
}
